// Detailed multi-service content for the Dienstleistungen page (5 languages).
// Each service: { id, title, tagline, intro, steps:[{t,d}], faq:[{q,a}] }.

export const serviceLabels = {
  de: { overview: "Übersicht", process: "Der Ablauf", faq: "Häufige Fragen", request: "Termin vereinbaren", call: "Jetzt anrufen" },
  en: { overview: "Overview", process: "The process", faq: "Frequently asked", request: "Book appointment", call: "Call now" },
  it: { overview: "Panoramica", process: "Il processo", faq: "Domande frequenti", request: "Fissa un appuntamento", call: "Chiama ora" },
  fr: { overview: "Aperçu", process: "Le déroulement", faq: "Questions fréquentes", request: "Prendre rendez-vous", call: "Appeler" },
  pt: { overview: "Visão geral", process: "O processo", faq: "Perguntas frequentes", request: "Marcar", call: "Ligar agora" },
};

export const servicesContent = {
  de: [
    {
      id: "raeumung", title: "Räumung", tagline: "Diskret, vollständig, einfühlsam",
      intro: "Wir räumen Wohnungen, Häuser und Liegenschaften vollständig und besenrein – zuverlässig, termingerecht und mit dem nötigen Feingefühl für persönliche Umstände.",
      steps: [
        { t: "Kostenlose Besichtigung", d: "Wir verschaffen uns vor Ort einen Überblick und besprechen Ihre Wünsche – unverbindlich und transparent." },
        { t: "Festes Angebot", d: "Sie erhalten ein klar kalkuliertes Pauschalangebot ohne versteckte Kosten." },
        { t: "Fachgerechte Räumung", d: "Unser Team räumt sorgfältig, trennt Wertvolles von der Entsorgung und arbeitet sauber." },
        { t: "Besenreine Übergabe", d: "Wir übergeben die Räumlichkeiten besenrein – bereit zur Rückgabe oder Neuvermietung." },
      ],
      faq: [
        { q: "Wie schnell können Sie räumen?", a: "In dringenden Fällen oft innerhalb weniger Tage – wir richten uns nach Ihrem Termin." },
        { q: "Was passiert mit noch brauchbaren Gegenständen?", a: "Werthaltiges bereiten wir auf und geben ihm über unsere Brockenstube sowie Ricardo und Tutti ein zweites Leben." },
      ],
    },
    {
      id: "entsorgung", title: "Entsorgung", tagline: "Fachgerecht und nachhaltig",
      intro: "Was nicht weiterverwendet werden kann, entsorgen wir umweltgerecht und nach den geltenden Basler Vorschriften – sortenrein getrennt und auf Wunsch dokumentiert.",
      steps: [
        { t: "Sortierung", d: "Wir trennen Wertstoffe, Sperrgut und Sonderabfälle sauber voneinander." },
        { t: "Umweltgerechte Entsorgung", d: "Die Entsorgung erfolgt über zertifizierte Partner und offizielle Sammelstellen." },
        { t: "Wiederverwertung zuerst", d: "Reparierbares und Verwertbares führen wir bevorzugt dem Kreislauf zu." },
      ],
      faq: [
        { q: "Entsorgen Sie auch Sonderabfälle?", a: "Ja, Sonderabfälle werden fachgerecht und dokumentiert über zugelassene Stellen entsorgt." },
        { q: "Erhalte ich einen Nachweis?", a: "Auf Wunsch stellen wir Ihnen eine Entsorgungsbestätigung aus." },
      ],
    },
    {
      id: "ankauf", title: "Ankauf", tagline: "Faire Bewertung, unkomplizierte Abwicklung",
      intro: "Wir kaufen Antiquitäten, Vintage-Möbel, Sammlerstücke und ganze Haushalte zu fairen Konditionen an – kompetent geschätzt und unkompliziert abgewickelt.",
      steps: [
        { t: "Einschätzung", d: "Senden Sie uns Fotos oder bringen Sie Ihre Stücke vorbei – wir schätzen den Wert ein." },
        { t: "Faires Angebot", d: "Sie erhalten ein transparentes Ankaufsangebot auf Basis aktueller Marktwerte." },
        { t: "Sofortige Abwicklung", d: "Bei Einigung zahlen wir umgehend aus und übernehmen den Transport." },
      ],
      faq: [
        { q: "Was kaufen Sie an?", a: "Antiquitäten, Möbel mit Charakter, Porzellan, Bilder, Uhren, Schmuck und ausgewählte Sammlerstücke." },
        { q: "Kaufen Sie auch ganze Nachlässe?", a: "Ja, wir übernehmen komplette Haushalte und Nachlässe." },
      ],
    },
    {
      id: "nachlass", title: "Nachlassauflösung", tagline: "Würdevoll und entlastend",
      intro: "Die Auflösung eines Nachlasses ist eine sensible Aufgabe. Wir begleiten Sie mit Respekt und Diskretion und übernehmen die gesamte Organisation für Sie.",
      steps: [
        { t: "Persönliches Gespräch", d: "Wir hören zu und stimmen das Vorgehen einfühlsam mit Ihnen ab." },
        { t: "Sichtung & Bewertung", d: "Wir sichten den Bestand, bewahren Erinnerungsstücke und bewerten Werthaltiges." },
        { t: "Vollständige Abwicklung", d: "Von Ankauf über Räumung bis zur besenreinen Übergabe – alles aus einer Hand." },
      ],
      faq: [
        { q: "Können persönliche Dokumente gesichert werden?", a: "Selbstverständlich. Wir bewahren Dokumente und Erinnerungsstücke sorgfältig auf und übergeben sie Ihnen." },
        { q: "Arbeiten Sie mit Behörden zusammen?", a: "Bei Bedarf koordinieren wir uns mit Verwaltungen, Erben und Ämtern." },
      ],
    },
    {
      id: "beratung", title: "Beratung & Schätzung", tagline: "Kompetenz vor Ort",
      intro: "Ob einzelner Wertgegenstand oder ganze Sammlung – wir beraten Sie fachkundig und schätzen den Wert Ihrer Stücke ein, gerne auch bei Ihnen zu Hause.",
      steps: [
        { t: "Terminvereinbarung", d: "Wir vereinbaren einen Termin bei Ihnen oder in unserer Wunderkammer." },
        { t: "Fachliche Einschätzung", d: "Unsere Kenner beurteilen Herkunft, Zustand und Marktwert." },
        { t: "Ehrliche Empfehlung", d: "Sie erhalten eine klare Empfehlung – Ankauf, Vermarktung oder Erhalt." },
      ],
      faq: [
        { q: "Ist die Erstberatung kostenlos?", a: "Eine erste Einschätzung ist bei uns unverbindlich und kostenlos." },
        { q: "Vermarkten Sie meine Stücke auch?", a: "Ja, über unsere Brockenstube sowie Ricardo und Tutti erreichen wir zahlreiche Interessenten." },
      ],
    },
  ],

  en: [
    { id: "raeumung", title: "Clearance", tagline: "Discreet, complete, empathetic",
      intro: "We clear apartments, houses and properties completely and broom-clean – reliably, on schedule and with the sensitivity personal circumstances deserve.",
      steps: [
        { t: "Free inspection", d: "We assess the situation on site and discuss your wishes – non-binding and transparent." },
        { t: "Fixed quote", d: "You receive a clearly calculated flat-rate offer with no hidden costs." },
        { t: "Professional clearance", d: "Our team works carefully, separating valuables from disposal and leaving everything tidy." },
        { t: "Broom-clean handover", d: "We hand over the premises broom-clean – ready for return or re-letting." },
      ],
      faq: [
        { q: "How quickly can you clear?", a: "In urgent cases often within a few days – we adapt to your schedule." },
        { q: "What happens to usable items?", a: "We refurbish valuable pieces and give them a second life through our store as well as Ricardo and Tutti." },
      ] },
    { id: "entsorgung", title: "Disposal", tagline: "Proper and sustainable",
      intro: "Whatever cannot be reused we dispose of in an environmentally sound way and in line with Basel regulations – neatly separated and documented on request.",
      steps: [
        { t: "Sorting", d: "We cleanly separate recyclables, bulky waste and hazardous materials." },
        { t: "Eco-friendly disposal", d: "Disposal is carried out via certified partners and official collection points." },
        { t: "Reuse first", d: "Repairable and recyclable items are returned to the cycle by preference." },
      ],
      faq: [
        { q: "Do you also dispose of hazardous waste?", a: "Yes, hazardous waste is disposed of properly and documented via approved facilities." },
        { q: "Do I receive proof?", a: "On request we issue a disposal confirmation." },
      ] },
    { id: "ankauf", title: "Purchase", tagline: "Fair valuation, easy handling",
      intro: "We purchase antiques, vintage furniture, collectibles and entire households on fair terms – expertly valued and handled without fuss.",
      steps: [
        { t: "Assessment", d: "Send us photos or bring your pieces by – we estimate their value." },
        { t: "Fair offer", d: "You receive a transparent purchase offer based on current market values." },
        { t: "Immediate handling", d: "Once agreed, we pay out promptly and take care of transport." },
      ],
      faq: [
        { q: "What do you buy?", a: "Antiques, furniture with character, porcelain, paintings, clocks, jewellery and selected collectibles." },
        { q: "Do you buy entire estates?", a: "Yes, we take over complete households and estates." },
      ] },
    { id: "nachlass", title: "Estate liquidation", tagline: "Dignified and relieving",
      intro: "Clearing an estate is a sensitive task. We accompany you with respect and discretion and take care of the entire organisation.",
      steps: [
        { t: "Personal conversation", d: "We listen and agree the approach sensitively with you." },
        { t: "Review & valuation", d: "We review the contents, preserve keepsakes and value what holds worth." },
        { t: "Complete handling", d: "From purchase to clearance to broom-clean handover – all from one source." },
      ],
      faq: [
        { q: "Can personal documents be secured?", a: "Of course. We carefully preserve documents and keepsakes and hand them over to you." },
        { q: "Do you work with authorities?", a: "When needed we coordinate with administrations, heirs and offices." },
      ] },
    { id: "beratung", title: "Consultation & appraisal", tagline: "Expertise on site",
      intro: "Whether a single valuable or a whole collection – we advise you expertly and estimate the value of your pieces, gladly at your home too.",
      steps: [
        { t: "Appointment", d: "We arrange a meeting at your place or in our chamber of wonders." },
        { t: "Expert assessment", d: "Our specialists assess origin, condition and market value." },
        { t: "Honest recommendation", d: "You receive a clear recommendation – purchase, marketing or preservation." },
      ],
      faq: [
        { q: "Is the initial consultation free?", a: "An initial assessment is non-binding and free of charge." },
        { q: "Do you also market my pieces?", a: "Yes, through our store as well as Ricardo and Tutti we reach many interested buyers." },
      ] },
  ],

  it: [
    { id: "raeumung", title: "Sgombero", tagline: "Discreto, completo, empatico",
      intro: "Sgomberiamo appartamenti, case e immobili in modo completo e pulito – in modo affidabile, puntuale e con la sensibilità che le circostanze personali richiedono.",
      steps: [
        { t: "Sopralluogo gratuito", d: "Valutiamo la situazione sul posto e discutiamo le vostre esigenze – senza impegno e in trasparenza." },
        { t: "Offerta fissa", d: "Ricevete un'offerta forfettaria chiara, senza costi nascosti." },
        { t: "Sgombero professionale", d: "Il nostro team lavora con cura, separando gli oggetti di valore da ciò che va smaltito." },
        { t: "Consegna pulita", d: "Consegniamo i locali puliti – pronti per la restituzione o una nuova locazione." },
      ],
      faq: [
        { q: "Con quanta rapidità sgomberate?", a: "Nei casi urgenti spesso entro pochi giorni – ci adattiamo alle vostre tempistiche." },
        { q: "Cosa succede agli oggetti ancora utilizzabili?", a: "Gli oggetti di valore vengono restaurati e trovano nuova vita tramite la nostra bottega, Ricardo e Tutti." },
      ] },
    { id: "entsorgung", title: "Smaltimento", tagline: "Corretto e sostenibile",
      intro: "Ciò che non può essere riutilizzato viene smaltito in modo ecologico e conforme alle norme di Basilea – separato per tipo e documentato su richiesta.",
      steps: [
        { t: "Selezione", d: "Separiamo con cura materiali riciclabili, ingombranti e rifiuti speciali." },
        { t: "Smaltimento ecologico", d: "Lo smaltimento avviene tramite partner certificati e punti di raccolta ufficiali." },
        { t: "Prima il riuso", d: "Ciò che è riparabile e riutilizzabile viene reintrodotto nel ciclo." },
      ],
      faq: [
        { q: "Smaltite anche i rifiuti speciali?", a: "Sì, i rifiuti speciali vengono smaltiti correttamente e documentati tramite centri autorizzati." },
        { q: "Ricevo una prova?", a: "Su richiesta rilasciamo una conferma di smaltimento." },
      ] },
    { id: "ankauf", title: "Acquisto", tagline: "Valutazione equa, gestione semplice",
      intro: "Acquistiamo antichità, mobili vintage, oggetti da collezione e interi arredamenti a condizioni eque – valutati con competenza e gestiti senza complicazioni.",
      steps: [
        { t: "Valutazione", d: "Inviateci foto o portate i vostri pezzi – ne stimiamo il valore." },
        { t: "Offerta equa", d: "Ricevete un'offerta d'acquisto trasparente basata sui valori di mercato attuali." },
        { t: "Gestione immediata", d: "Trovato l'accordo, paghiamo subito e ci occupiamo del trasporto." },
      ],
      faq: [
        { q: "Cosa acquistate?", a: "Antichità, mobili di carattere, porcellane, quadri, orologi, gioielli e oggetti da collezione selezionati." },
        { q: "Acquistate anche intere eredità?", a: "Sì, ci occupiamo di interi arredamenti ed eredità." },
      ] },
    { id: "nachlass", title: "Liquidazione di eredità", tagline: "Dignitosa e di sollievo",
      intro: "La liquidazione di un'eredità è un compito delicato. Vi accompagniamo con rispetto e discrezione, occupandoci di tutta l'organizzazione.",
      steps: [
        { t: "Colloquio personale", d: "Vi ascoltiamo e concordiamo con sensibilità il modo di procedere." },
        { t: "Esame e valutazione", d: "Esaminiamo i beni, conserviamo i ricordi e valutiamo ciò che ha valore." },
        { t: "Gestione completa", d: "Dall'acquisto allo sgombero fino alla consegna pulita – tutto da un unico interlocutore." },
      ],
      faq: [
        { q: "È possibile mettere al sicuro i documenti personali?", a: "Naturalmente. Conserviamo con cura documenti e ricordi e ve li consegniamo." },
        { q: "Collaborate con le autorità?", a: "Se necessario ci coordiniamo con amministrazioni, eredi e uffici." },
      ] },
    { id: "beratung", title: "Consulenza e stima", tagline: "Competenza sul posto",
      intro: "Che si tratti di un singolo oggetto di valore o di un'intera collezione – vi consigliamo con competenza e stimiamo il valore dei vostri pezzi, anche a casa vostra.",
      steps: [
        { t: "Appuntamento", d: "Fissiamo un incontro da voi o nella nostra camera delle meraviglie." },
        { t: "Valutazione esperta", d: "I nostri esperti valutano provenienza, stato e valore di mercato." },
        { t: "Raccomandazione onesta", d: "Ricevete una raccomandazione chiara – acquisto, vendita o conservazione." },
      ],
      faq: [
        { q: "La prima consulenza è gratuita?", a: "Una prima valutazione è senza impegno e gratuita." },
        { q: "Commercializzate anche i miei pezzi?", a: "Sì, tramite la nostra bottega, Ricardo e Tutti raggiungiamo numerosi interessati." },
      ] },
  ],

  fr: [
    { id: "raeumung", title: "Débarras", tagline: "Discret, complet, empathique",
      intro: "Nous débarrassons entièrement appartements, maisons et biens immobiliers – de manière fiable, ponctuelle et avec la délicatesse que méritent les situations personnelles.",
      steps: [
        { t: "Visite gratuite", d: "Nous évaluons la situation sur place et discutons de vos souhaits – sans engagement et en toute transparence." },
        { t: "Devis ferme", d: "Vous recevez une offre forfaitaire claire, sans coûts cachés." },
        { t: "Débarras professionnel", d: "Notre équipe travaille avec soin, séparant les objets de valeur de ce qui doit être éliminé." },
        { t: "Remise nettoyée", d: "Nous remettons les lieux nettoyés – prêts pour la restitution ou une nouvelle location." },
      ],
      faq: [
        { q: "À quelle vitesse pouvez-vous débarrasser ?", a: "Dans les cas urgents souvent en quelques jours – nous nous adaptons à votre calendrier." },
        { q: "Que deviennent les objets encore utilisables ?", a: "Les pièces de valeur sont restaurées et retrouvent une seconde vie via notre brocante ainsi que Ricardo et Tutti." },
      ] },
    { id: "entsorgung", title: "Élimination", tagline: "Correcte et durable",
      intro: "Ce qui ne peut être réutilisé est éliminé de manière écologique et conforme aux prescriptions bâloises – trié par type et documenté sur demande.",
      steps: [
        { t: "Tri", d: "Nous séparons proprement les matières recyclables, les encombrants et les déchets spéciaux." },
        { t: "Élimination écologique", d: "L'élimination se fait via des partenaires certifiés et des points de collecte officiels." },
        { t: "Le réemploi d'abord", d: "Ce qui est réparable et valorisable est réintroduit dans le cycle en priorité." },
      ],
      faq: [
        { q: "Éliminez-vous aussi les déchets spéciaux ?", a: "Oui, les déchets spéciaux sont éliminés correctement et documentés via des centres agréés." },
        { q: "Ai-je une preuve ?", a: "Sur demande, nous établissons une confirmation d'élimination." },
      ] },
    { id: "ankauf", title: "Achat", tagline: "Évaluation équitable, gestion simple",
      intro: "Nous achetons antiquités, meubles vintage, objets de collection et ménages entiers à des conditions équitables – estimés avec expertise et traités sans complications.",
      steps: [
        { t: "Estimation", d: "Envoyez-nous des photos ou apportez vos pièces – nous en estimons la valeur." },
        { t: "Offre équitable", d: "Vous recevez une offre d'achat transparente basée sur les valeurs actuelles du marché." },
        { t: "Traitement immédiat", d: "Une fois d'accord, nous payons rapidement et nous chargeons du transport." },
      ],
      faq: [
        { q: "Qu'achetez-vous ?", a: "Antiquités, meubles de caractère, porcelaine, tableaux, horloges, bijoux et objets de collection choisis." },
        { q: "Achetez-vous des successions entières ?", a: "Oui, nous reprenons des ménages complets et des successions." },
      ] },
    { id: "nachlass", title: "Liquidation de succession", tagline: "Digne et soulageante",
      intro: "La liquidation d'une succession est une tâche sensible. Nous vous accompagnons avec respect et discrétion et prenons en charge toute l'organisation.",
      steps: [
        { t: "Entretien personnel", d: "Nous vous écoutons et convenons de la démarche avec sensibilité." },
        { t: "Examen et évaluation", d: "Nous examinons les biens, préservons les souvenirs et évaluons ce qui a de la valeur." },
        { t: "Traitement complet", d: "De l'achat au débarras jusqu'à la remise nettoyée – tout d'une seule main." },
      ],
      faq: [
        { q: "Les documents personnels peuvent-ils être sécurisés ?", a: "Bien sûr. Nous conservons soigneusement documents et souvenirs et vous les remettons." },
        { q: "Travaillez-vous avec les autorités ?", a: "Si nécessaire, nous nous coordonnons avec les administrations, héritiers et offices." },
      ] },
    { id: "beratung", title: "Conseil et estimation", tagline: "Compétence sur place",
      intro: "Qu'il s'agisse d'un seul objet de valeur ou d'une collection entière – nous vous conseillons avec expertise et estimons la valeur de vos pièces, volontiers chez vous aussi.",
      steps: [
        { t: "Rendez-vous", d: "Nous convenons d'un rendez-vous chez vous ou dans notre cabinet de curiosités." },
        { t: "Évaluation experte", d: "Nos spécialistes évaluent l'origine, l'état et la valeur marchande." },
        { t: "Recommandation honnête", d: "Vous recevez une recommandation claire – achat, vente ou conservation." },
      ],
      faq: [
        { q: "La première consultation est-elle gratuite ?", a: "Une première estimation est sans engagement et gratuite." },
        { q: "Commercialisez-vous aussi mes pièces ?", a: "Oui, via notre brocante ainsi que Ricardo et Tutti, nous atteignons de nombreux intéressés." },
      ] },
  ],

  pt: [
    { id: "raeumung", title: "Remoção", tagline: "Discreta, completa, empática",
      intro: "Removemos apartamentos, casas e imóveis por completo e deixamo-los limpos – de forma fiável, pontual e com a sensibilidade que as circunstâncias pessoais merecem.",
      steps: [
        { t: "Visita gratuita", d: "Avaliamos a situação no local e discutimos os seus desejos – sem compromisso e com transparência." },
        { t: "Orçamento fixo", d: "Recebe uma proposta fixa clara, sem custos ocultos." },
        { t: "Remoção profissional", d: "A nossa equipa trabalha com cuidado, separando os objetos de valor do que deve ser eliminado." },
        { t: "Entrega limpa", d: "Entregamos o espaço limpo – pronto para devolução ou novo arrendamento." },
      ],
      faq: [
        { q: "Com que rapidez conseguem remover?", a: "Em casos urgentes muitas vezes em poucos dias – adaptamo-nos ao seu prazo." },
        { q: "O que acontece aos objetos ainda utilizáveis?", a: "As peças de valor são restauradas e ganham nova vida através da nossa loja, do Ricardo e do Tutti." },
      ] },
    { id: "entsorgung", title: "Eliminação", tagline: "Correta e sustentável",
      intro: "O que não pode ser reutilizado é eliminado de forma ecológica e em conformidade com as normas da Basileia – separado por tipo e documentado a pedido.",
      steps: [
        { t: "Triagem", d: "Separamos cuidadosamente recicláveis, volumosos e resíduos especiais." },
        { t: "Eliminação ecológica", d: "A eliminação é feita através de parceiros certificados e pontos de recolha oficiais." },
        { t: "Reutilização primeiro", d: "O que é reparável e aproveitável é devolvido ao ciclo por preferência." },
      ],
      faq: [
        { q: "Também eliminam resíduos especiais?", a: "Sim, os resíduos especiais são eliminados corretamente e documentados através de centros autorizados." },
        { q: "Recebo um comprovativo?", a: "A pedido, emitimos uma confirmação de eliminação." },
      ] },
    { id: "ankauf", title: "Compra", tagline: "Avaliação justa, tratamento simples",
      intro: "Compramos antiguidades, mobiliário vintage, peças de coleção e casas inteiras em condições justas – avaliados com competência e tratados sem complicações.",
      steps: [
        { t: "Avaliação", d: "Envie-nos fotos ou traga as suas peças – estimamos o valor." },
        { t: "Proposta justa", d: "Recebe uma proposta de compra transparente com base nos valores de mercado atuais." },
        { t: "Tratamento imediato", d: "Havendo acordo, pagamos de imediato e tratamos do transporte." },
      ],
      faq: [
        { q: "O que compram?", a: "Antiguidades, mobiliário com carácter, porcelana, quadros, relógios, joias e peças de coleção selecionadas." },
        { q: "Compram heranças inteiras?", a: "Sim, assumimos casas completas e heranças." },
      ] },
    { id: "nachlass", title: "Liquidação de heranças", tagline: "Digna e aliviadora",
      intro: "A liquidação de uma herança é uma tarefa sensível. Acompanhamo-lo com respeito e discrição e tratamos de toda a organização.",
      steps: [
        { t: "Conversa pessoal", d: "Ouvimo-lo e definimos o procedimento com sensibilidade." },
        { t: "Análise e avaliação", d: "Analisamos os bens, preservamos recordações e avaliamos o que tem valor." },
        { t: "Tratamento completo", d: "Da compra à remoção até à entrega limpa – tudo a partir de um único parceiro." },
      ],
      faq: [
        { q: "Os documentos pessoais podem ser guardados?", a: "Claro. Guardamos cuidadosamente documentos e recordações e entregamo-los a si." },
        { q: "Trabalham com autoridades?", a: "Quando necessário, coordenamo-nos com administrações, herdeiros e serviços." },
      ] },
    { id: "beratung", title: "Aconselhamento e avaliação", tagline: "Competência no local",
      intro: "Seja um único objeto de valor ou uma coleção inteira – aconselhamo-lo com competência e estimamos o valor das suas peças, com gosto também em sua casa.",
      steps: [
        { t: "Marcação", d: "Marcamos um encontro em sua casa ou na nossa câmara das maravilhas." },
        { t: "Avaliação especializada", d: "Os nossos especialistas avaliam origem, estado e valor de mercado." },
        { t: "Recomendação honesta", d: "Recebe uma recomendação clara – compra, venda ou preservação." },
      ],
      faq: [
        { q: "A primeira consulta é gratuita?", a: "Uma primeira avaliação é sem compromisso e gratuita." },
        { q: "Também comercializam as minhas peças?", a: "Sim, através da nossa loja, do Ricardo e do Tutti alcançamos muitos interessados." },
      ] },
  ],
};
